import styled from 'styled-components';

export const PageArea = styled.div`
  .signup-container {
    display: flex;
    gap: 40px;
    align-items: flex-start;
    justify-content: center;
  }

  .divider {
    width: 2px;
    background: linear-gradient(to bottom, transparent, #667eea, transparent);
    min-height: 400px;
    align-self: stretch;
  }

  form {
    background-color: #fff;
    border-radius: 3px;
    padding: 15px;
    box-shadow: 0px 0px 3px #999;
    min-width: 550px;
    width: 100%;
    max-width: 550px;

    .area {
      display: flex;
      align-items: center;
      padding: 12px;
      max-width: 550px;

      .area--title {
        width: 200px;
        text-align: right;
        padding-right: 20px;
        font-weight: bold;
        font-size: 14px;
      };

      .area--input {
        display: flex;
        flex: 1;

        input {
          width: 100%;
          font-size: 14px;
          padding: 5px;
          border: 1px solid #ddd;
          border-radius: 3px;
          outline: 0;
          transition: all 0.4s ease-in-out 0s;

          &:focus{
            border: 1px solid #333;
            color: #333;
          };
        };

        select {
          width: 100%;
          height: 28px;
          border: 1px solid #ddd;
        };

        button {
          background-color: #0089ff;
          border: 0;
          outline: 0;
          padding: 5px 10px;
          border-radius: 4px;
          color: #fff;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.2s ease-in-out 0s;

          &:hover {
            background-color: #006fce;
          };
        };
      };
    };
  };

  .oauth-signin {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 300px;
    gap: 20px;

    .oauth-title {
      font-size: 18px;
      color: #666;
      margin: 0;
      font-weight: 500;
    }

    .oauth-buttons {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 100%;
    }

    .oauth-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
      width: 100%;
      max-width: 500px;
      padding: 40px 20px;
      background-color: #fff;
      border: 2px solid #ddd;
      border-radius: 8px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);

      &:hover {
        background-color: #f8f9fa;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        border-color: #667eea;
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      svg {
        width: 48px;
        height: 48px;
      }
    }

    .apple-btn {
      background-color: #000;
      color: #fff;
      border-color: #000;

      &:hover {
        background-color: #333;
        border-color: #333;
      }
    }
  }

  @media(max-width: 900px){
    .signup-container {
      flex-direction: column;
      align-items: center;
    }

    .divider {
      width: 80%;
      height: 2px;
      min-height: unset;
      margin: 20px 0;
    }

    .oauth-signin {
      width: 100%;
      max-width: 500px;

      .oauth-btn {
        padding: 20px 15px;
        font-size: 16px;
        gap: 12px;

        svg {
          width: 36px;
          height: 36px;
        }
      }
    }

    form {
      min-width: unset;
      width: 100%;
      max-width: 100%;

      .area {
        flex-flow: column;

        .area--title {
          width: 100%;
          text-align: left;
          margin-bottom: 10px;
        };

        .area--input {
          width: 100%;

          select {
            padding: 5px;
          };

          button {
            width: 100%;
            padding: 10px;
          };
        };
      };
    };
  };
`;